var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProfileModal',{attrs:{"show":_vm.show,"loading":_vm.isLoading,"hasUnsavedChanges":_vm.hasUnsavedChanges},on:{"close":function($event){return _vm.$emit('close')},"save":_vm.handleSave}},[(_vm.builder)?_c('JobPreferencesForm',{staticClass:"mx-4",attrs:{"builder":_vm.builder,"loading":_vm.isLoading}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }